import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IMAGEM_LOGO_CENTRUS_BASE64 } from '../../../../../../app.constants';
import { PessoaDadosSimplicadosModel } from '../../../../models/pessoa-simplificada.model';
import { SEFSaldoFinanceiroModel } from '../../../../models/sef-saldo-financeiro.model';
import { CpfPipe } from '../../../../pipe/cpf-pipe';
import { FormateNumberZeroPipe } from '../../../../pipe/format-number-zero.pipe';

@Injectable()
export class SEFSaldoFinanciamentoPdf {

  constructor(
    private _decimalPipe: DecimalPipe,
    private _formateNumberZeroPipe: FormateNumberZeroPipe,
    private _cpf: CpfPipe
  ) { }

  public funcionarios(pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel, sEFSaldoFinanceiroModel: Array<SEFSaldoFinanceiroModel>, dadosTabelaPrestacao: any[],
    mensagemFooter: string, mensagemInformativa: string, mensagemSaldoInf: string, mensagemAcessarInf: string) {


    const doc = new jsPDF('p', 'mm', 'a4');

    doc.addImage(IMAGEM_LOGO_CENTRUS_BASE64, 'PNG', 90, 20, 30, 20);
    doc.setFontSize(13);
    doc.setFont('Source Sans Pro');
    doc.setFontStyle('bold');
    doc.text(`CONSULTA SALDO DE FINANCIAMENTO`, 70, 50)

    doc.autoTable({
      startY: 60
    })

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 10,
      },
      head: [['CPF', 'Nome']],
      body: [[this._cpf.transform(pessoaDadosSimplicadosModel.cpf), pessoaDadosSimplicadosModel.nome]],
    });


    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 9,
      },
      footStyles: {
        fillColor: [226, 235, 248],
      },
      head: this._headRowsTablePrincipal(),
      body: this._bodyRowsTablePrincipal(sEFSaldoFinanceiroModel)
    });


    if (mensagemInformativa) {
      doc.setFontSize(10);
      doc.setFont('Source Sans Pro');
      doc.text(mensagemInformativa, 60, doc.previousAutoTable.finalY + 10)
    }

    if (mensagemSaldoInf) {
      doc.setFontSize(10);
      doc.setFont('Source Sans Pro');
      doc.text(mensagemSaldoInf, 60, doc.previousAutoTable.finalY + 10)
    }

    if (mensagemAcessarInf) {
      doc.setFontSize(10);
      doc.setFont('Source Sans Pro');
      doc.text(mensagemAcessarInf, 60, doc.previousAutoTable.finalY + 10)
    }

    doc.autoTable({ body: [] })

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 9,
      },
      footStyles: {
        fillColor: [226, 235, 248],
      },
      head: this._headRowsTableSecundaria(),
      body: this._bodyRowsTableSecundaria(dadosTabelaPrestacao)
    });


    doc.setFontSize(10);
    doc.setFont('Source Sans Pro');
    doc.text(mensagemFooter, 16, doc.previousAutoTable.finalY + 10)


    doc.setProperties({
      title: 'SEF - SALDO FINANCIAMENTO',
      subject: `CONSULTA SALDO DE FINANCIAMENTO `,
      author: 'centrus',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'Fundação Banco central de previcência provida - centrus'
    });

    (window.innerWidth > 640)
      ? (window.open(URL.createObjectURL(doc.output('blob'))))
      : this.handleFile(doc.output('blob'), 'sef.pdf');
  }

  handleFile(res: any, fileName: string) {
    const file = new Blob([res], {
      type: res.type
    });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file);
      return;
    }



    const blob = window.URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = blob;
    link.download = fileName;

    // link.click();
    link.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    setTimeout(() => { // firefox
      window.URL.revokeObjectURL(blob);
      link.remove();
    }, 100);
  }


  private _bodyRowsTablePrincipal(sEFSaldoFinanceiroModel: Array<SEFSaldoFinanceiroModel>) {
    const body = []
    sEFSaldoFinanceiroModel.map(item => {
      body.push({
        descricao: item.dsRegulamento,
        dtSaldo: item.dtSlado,
        sdDevedor: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlSaldoDevedor, '1.1-2')),
        ptAtraso: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlPrestAtraso, '1.1-2')),
        vlLiquidacao: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlSaldoTotal, '1.1-2'))
      })
    })
    return body;
  }


  private _headRowsTablePrincipal() {
    return [{
      descricao: 'Descrição',
      dtSaldo: 'Data Saldo',
      sdDevedor: 'Saldo Devedor',
      ptAtraso: 'Prestações em Atraso ',
      vlLiquidacao: 'Valor para Liquidação'
    },
    ]
  }

  private _bodyRowsTableSecundaria(dadosTabelaPrestacao: any[]) {
    const body = []
    dadosTabelaPrestacao.map(item => {
      body.push({
        dtPrestacoa: item.dp,
        parcPrazo: item.descricao,
        numero: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.valor, '1.1-2'))
      })
    })
    return body;
  }


  private _headRowsTableSecundaria() {
    return [{
      dtPrestacoa: 'Dados da Prestação',
      parcPrazo: 'Parcela/Prazo',
      numero: '93 / 119'
    },
    ]
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos-pdf-imprimir/financeiro/SEF/sef-saldo-financiamento-pdf.ts